module.exports = __webpack_public_path__ + "img/folder.26dd3780.svg";